<template>
	<div class="custom-test-settings-form">
		<v-row no-gutters class="mt-1">
			<v-col cols="12" sm="6">
				<v-form ref="testForm">
					<v-text-field
						v-model="customTest.name"
						:label="$gettext('Name')"
						class="px-2"
						:rules="[required]"
						filled
					></v-text-field>
				</v-form>
			</v-col>
		</v-row>
		<p class="text-subtitle-1">Items</p>
		<v-row no-gutters>
			<v-btn fab color="primary" @click="showNewField = !showNewField" small>
				<v-icon>mdi-plus</v-icon>
			</v-btn>
			<v-spacer></v-spacer>
			<Variables v-if="showVariables" :variables="variables" />
		</v-row>
    <v-form v-if="showNewField" ref="newFieldForm">
		<v-row no-gutters class="mt-2">
      <v-col cols="12">
				<v-textarea
					v-model="newField.name"
					:placeholder="$gettext('Name')"
					outlined
					class="px-2"
					:rules="[required]"
					hide-details
					auto-grow
				></v-textarea>
			</v-col>
			<v-col cols="12" class="mt-3">
				<v-row no-gutters justify="center" align="center">
          <v-select
						:items="answerTypes"
						:label="$gettext('Answer')"
						v-model="newField.test_variable"
						class="px-2"
						outlined
						:rules="[required]"
						item-text="name"
						item-value="id"
            dense
            hide-details
            return-object
            @change="resetTestVariable(newField)"
					></v-select>
					<template v-if="newField.test_variable && newField.test_variable.id == 3">
						<span class="ml-3 black--text">1 -</span>
						<v-text-field
							v-model="newField.degree_max"
							outlined
							class="px-2 shrink"
							:rules="[required]"
							dense
							hide-details
							style="width: 60px"
							height="2"
						></v-text-field>
					</template>
					<v-spacer></v-spacer>
				</v-row>
			</v-col>
      <v-col v-if="newField.test_variable && newField.test_variable.options.length > 0" cols="12" class="mt-4">
        <span class="text-subtitle-2">Associar ICDs</span>
        <v-row v-for="option in newField.test_variable.options" :key="option.id" no-gutters class="py-3" align="center">
          {{option.name}}
          <v-btn fab color="primary" x-small @click="currentField = newField; currentOption = option; showICDs = true" class="ml-2">
            <v-icon small>mdi-plus</v-icon>
          </v-btn>
          <v-chip v-for="icd in fieldOptionICDs(newField, option)" :key="icd.id" class="mx-1">{{icd.code}} - {{icd.name}}</v-chip>
        </v-row>
      </v-col>
			<v-col cols="12">
				<v-btn depressed color="secondary" class="primary--text float-right ma-3" @click="addField(true)" small>
					<v-icon small class="mr-1">mdi-check-bold</v-icon>
					<translate>Save</translate>
				</v-btn>
			</v-col>
		</v-row>
    </v-form>
		<v-row no-gutters class="mt-2">
			<v-col cols="12">
				<p v-if="customTest.fields.length == 0" class="font-weight-thin ml-2" v-translate>
					No items.
				</p>
				<v-list v-else>
					<v-list-item
						v-for="(field, i) in customTest.fields"
						:key="i"
						style="border: 1px solid #e0e0e0; border-radius: 5px"
					>
						<v-list-item-content>
							<v-list-item-title>
								<v-row v-if="field.edit" no-gutters class="mt-2">
									<v-col cols="12">
										<v-form ref="newFieldForm">
											<v-textarea
												v-model="field.name"
												:placeholder="$gettext('Name')"
												outlined
												class="px-2"
												:rules="[required]"
												hide-details
											></v-textarea>
										</v-form>
									</v-col>
									<v-col cols="12" class="mt-3">
										<v-row no-gutters justify="center" align="center">
                      <v-select
                        :items="answerTypes"
                        :label="$gettext('Answer')"
                        v-model="field.test_variable"
                        class="px-2"
                        outlined
                        :rules="[required]"
                        item-text="name"
                        item-value="id"
                        dense
                        hide-details
                        return-object
                      ></v-select>
											<template v-if="field.test_variable && field.test_variable.id == 3">
												<span class="ml-3 black--text">1 -</span>
												<v-text-field
													v-model="field.degree_max"
													outlined
													class="px-2 shrink"
													:rules="[required]"
													dense
													hide-details
													style="width: 60px"
													height="2"
												></v-text-field>
											</template>
											<v-spacer></v-spacer>
                      <v-col v-if="field.test_variable && field.test_variable.options.length > 0" cols="12" class="mt-4 ml-5">
                        <span class="text-subtitle-2">Associar ICDs</span>
                        <v-row v-for="option in field.test_variable.options" :key="option.id" no-gutters class="py-3" align="center">
                          {{option.name}}
                          <v-btn fab color="primary" x-small @click="currentField = field; currentOption = option; showICDs = true" class="ml-2">
                            <v-icon small>mdi-plus</v-icon>
                          </v-btn>
                          <v-chip v-for="icd in fieldOptionICDs(field, option)" :key="icd.id" class="mx-1">{{icd.code}} - {{icd.title}}</v-chip>
                        </v-row>
                      </v-col>
											<v-col cols="12">
												<v-btn depressed color="secondary" class="primary--text float-right" @click="field.edit = false" small>
													<v-icon small>mdi-check-bold</v-icon>
													<translate>Save</translate>
												</v-btn>
											</v-col>
										</v-row>
									</v-col>
								</v-row>
								<v-row v-else no-gutters align="center">
									<v-col cols="12" sm="10">
										<div style="white-space: pre-wrap" class="ma-3">{{field.name}}</div>
									</v-col>
									<v-col cols="12" sm="2">
										<v-chip>
											{{ getFieldName(field.test_variable) }}
											<span v-if="field.test_variable.id == 3" class="ml-1">
                        - {{ field.degree_max }}
                      </span>
										</v-chip>
									</v-col>
								</v-row>
							</v-list-item-title>
						</v-list-item-content>
						<v-list-item-action class="ma-0 ml-2">
							<v-row no-gutters>
								<v-btn icon small @click="field.edit = true">
									<v-icon color="primary">mdi-pencil</v-icon>
								</v-btn>
								<v-btn icon small @click="removeField(field, true)">
									<v-icon color="primary">delete</v-icon>
								</v-btn>
							</v-row>
						</v-list-item-action>
					</v-list-item>
				</v-list>
			</v-col>
		</v-row>
    <v-dialog v-model="showICDs" max-width="50%" scrollable>
			<v-card v-if="showICDs">
				<v-card-title class="title primary--text mb-2 secondary">
          ICDs {{currentField.name}} - {{currentOption.name}}
				</v-card-title>
				<v-card-text>
          <SearchICD class="px-2" context="tests" :selectedICD="fieldOptionICDs(currentField, currentOption)" />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="primary" text @click="showICDs = false">
            <translate>Close</translate>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
	</div>
</template>

<script>
import Variables from './Variables.vue';
import SearchICD from "@/components/icd/SearchICD.vue";

export default {
  name: "CustomTestSettingsForm",
  props: ["customTest", "variables"],
  components: {
    Variables,
    SearchICD
  },
  data: () => ({
    showNewField: false,
    newField: {
      id: -1,
      name: "",
      test_variable: null,
      degree_max: 5,
      edit: false,
      icds: {}
		},
    currentField: null,
    currentOption: null,
    showICDs: false
  }),
  computed: {
    required() {
			return value => !!value || this.$gettext("Required.");
    },
    answerTypes() {
      let types = [
        {id: 1, name: this.$gettext("Text"), options: []},
        {id: 2, name: this.$gettext("Boolean"), options: [{id: 1, name: this.$gettext("Yes")}, {id: 2, name: this.$gettext("No")}]},
        {id: 3, name: this.$gettext("Degree"), options: []}
      ]
      return types.concat(this.variables);
    },
    fieldOptionICDs: () => (field, option)=> {
      return field.icds[option.id];
      //return field.icds.filter(i => {i.test_variable_option_id == option.id});
    },
		showVariables() {
			if(this.showNewField) return true;
			for(let i=0; i < this.customTest.fields.length; i++) {
				if(this.customTest.fields[i].edit) return true;
			}
			return false;
		}
  },
  methods: {
    addField(edit) {
      if(this.$refs.newFieldForm.validate()) {
        if(edit) this.customTest.fields.push(JSON.parse(JSON.stringify(this.newField)));
        else this.newTest.fields.push(JSON.parse(JSON.stringify(this.newField)));
        this.newField.name = "";
        this.newField.test_variable = null;
        this.newField.icds = [];
        this.showNewField = false;
      }
    },
    removeField(field, edit) {
      if(edit) this.customTest.fields.splice(this.customTest.fields.indexOf(field), 1);
      else this.newTest.fields.splice(this.newTest.fields.indexOf(field), 1);
    },
    getFieldName(testVariable) {
      let id = testVariable.id;
      if(id == 1 || id == 2 || id == 3) {
        return this.answerTypes[id - 1].name;
      }
      return testVariable.name;
    },
    validate() {
      return this.$refs.testForm.validate();
    },
    resetTestVariable(field) {
      field.icds = {};
      for(let i=0; i < field.test_variable.options.length; i++) {
        //field.icds[field.test_variable.options[i].id] = [];
        this.$set(field.icds, field.test_variable.options[i].id, []);
      }
    }
  },
  created() {
    for(let i = 0; i < this.customTest.fields.length; i++) {
			this.$set(this.customTest.fields[i], 'edit', false);
      for(let h = 0; h < this.customTest.fields[i].test_variable.options.length; h++) {
        if(!(this.customTest.fields[i].test_variable.options[h].id in this.customTest.fields[i].icds)) {
          this.$set(this.customTest.fields[i].icds, this.customTest.fields[i].test_variable.options[h].id, []);
        }
      }
		}
  }
}
</script>